/*** React Apps ****/

// jumpNavigation needs to be before DynamicContentListing
import renderJumpNavigation from "./components/JumpNavigation/renderJumpNavigation.jsx";
import renderChapterNavigation from "./components/ChapterNavigation/renderChapterNavigation.jsx";
import renderDynamicLeadershipListing from "./components/DynamicLeadershipListing/renderDynamicLeadershipListing.jsx";
import renderDynamicContentListing from "./components/DynamicContentListing/renderDynamicContentListing.jsx";
import renderSearchComponent from "./components/SearchComponent/renderSearchComponent.jsx";
import renderShareBar from "./components/ShareBar/renderShareBar.jsx";
import renderYouTubeVideo from "./components/YouTubeVideo/renderYouTubeVideo.jsx";
import renderTypeaheadSearch from "./components/TypeaheadSearch/renderTypeaheadSearch.jsx";
import renderSiteHeader from "./components/SiteHeader/renderSiteHeader.jsx";
import renderTimeline from "./components/Timeline/renderTimeline.jsx";
import renderFrameworkModal from "./components/Framework/FrameworkModal/renderFrameworkModal.jsx";
import renderCardSlider from "./components/CardSlider/renderCardSlider.jsx";
import renderQuiz from "./components/Quiz/renderQuiz.jsx";
import renderCountdownBanner from "./components/CountdownBanner/renderCountdownBanner.jsx";

// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", () => {
  renderChapterNavigation();
  renderCountdownBanner();
  renderDynamicContentListing();
  renderSearchComponent();
  renderDynamicLeadershipListing();
  renderJumpNavigation();
  renderYouTubeVideo();
  renderTypeaheadSearch();
  renderShareBar();
  renderSiteHeader();
  renderTimeline();
  renderFrameworkModal();
  renderCardSlider();
  renderQuiz();
});
